/* eslint-disable */
export const apiConfig = {
  apiClientScope: window?.env?.REACT_APP_MSAL_SCOPE ?? 'api://bc5b3575-b620-4e1d-a5a8-c6bb0da45df0/searches-frontend'
}
